export default "__VITE_ASSET__9ec6e280__"